import React from 'react';
import PropTypes from 'prop-types';

const MultipleTransactionInfoContent = ({ config }) => {
  return (
    <div className={`info`}>
      {config &&
        config.length > 0 &&
        config.map(
          ({ title, value, titleClassName, valueClassName, parentClassName, note }, key) => (
            <div
              key={key}
              className={`flex-justify-spaces-between ${parentClassName} ${
                note ? 'note-wrapper' : ''
              }`}
            >
              <div className="title-wrapper">
                <span className={`title ${titleClassName}`}>{title}</span>
                {note && <span className="info-note">{note}</span>}
              </div>
              <span className={`value ${valueClassName}`}>{value}</span>
            </div>
          )
        )}
    </div>
  );
};

MultipleTransactionInfoContent.propTypes = {
  viewFor: PropTypes.string,
  config: PropTypes.array
};

export default MultipleTransactionInfoContent;
